// frontend/src/components/matching/availability.js
const STATUS_TITLE = {
  beschikbaar: 'beschikbaar',
  deels_beschikbaar: 'deels beschikbaar',
  niet_beschikbaar: 'niet beschikbaar',
};

/** Zet een beschikbaarheid-object om naar badge-props, of null.
 *  Toont alleen de status (beschikbaar / deels / niet), nooit een aantal uren per week. */
export function availabilityBadge(beschikbaarheid) {
  if (!beschikbaarheid) return null;
  const { vanaf, status } = beschikbaarheid;
  const vanafTxt = vanaf ? ` vanaf ${vanaf}` : '';
  const statusTxt = STATUS_TITLE[status] || status;
  return {
    label: statusTxt,
    statusKey: status,
    title: `${statusTxt}${vanafTxt}`,
  };
}
